import { t } from '@lingui/core/macro';
import { OfferIconMUI } from 'components/icons/OfferIconMUI';
import { WarningIconMUI2 } from 'components/icons/WarningIconMUI2';
import { NavSection } from 'components/nav-section/NavSection';
import type { NavListProps } from 'components/nav-section/type';
import SvgIcon from 'components/SvgIcon';
import { useCurrentGroupOrThrow, useCurrentRole } from 'hooks/slices';
import { truthy } from 'utils/arrayUtils';

export function GroupNavSection() {
  const currentRole = useCurrentRole();
  const isResourceAdmin = currentRole && currentRole.kind === 'group_admin';
  const { id: groupId } = useCurrentGroupOrThrow();

  const navItems: NavListProps[] = [
    {
      title: t`Dashboard`,
      to: '/group/dashboard' as const,
      icon: <SvgIcon name="ic_mail" />,
    },
    {
      title: t`Pharmacies`,
      to: '/group/pharmacies' as const,
      icon: <SvgIcon name="ic_pharma" />,
    },
    {
      title: t`Réclamations`,
      to: '/group/claims' as const,
      icon: <WarningIconMUI2 />,
    },
    {
      title: t`Laboratoires`,
      to: '/group/groups_labs' as const,
      icon: <SvgIcon name="ic_lab" />,
    },
    {
      title: t`Opérations`,
      to: '/group/trades' as const,
      icon: <OfferIconMUI />,
    },
    isResourceAdmin && {
      title: t`Paramètres`,
      to: '/group/$id/edit' as const,
      params: { id: groupId },
      icon: <SvgIcon name="ic_settings" />,
    },
    {
      title: 'Aide',
      href: 'https://intercom.help/faks/fr',
      icon: <SvgIcon name="ic_question" />,
    },
  ].filter(truthy);

  return <NavSection navItems={navItems} />;
}
